import { Globe } from 'lucide-react';
import { useMapStore } from '@/stores/map-store';
import { useStreetViewStore } from '@/stores/street-view-store';
import { useEntitySelectionStore } from '@/stores/entity-selection-store';

/** HUD chip that resets the camera to the default overhead view. */
export function ResetViewControl(): React.JSX.Element {
  function reset(): void {
    useMapStore.getState().resetView();
    useStreetViewStore.getState().close();
    useEntitySelectionStore.getState().clear();
  }

  return (
    <button
      type="button"
      onClick={reset}
      title="Reset view"
      className="flex items-center gap-2 rounded-lg border border-echo-border bg-echo-grey/90 px-2.5 py-2 shadow-lg backdrop-blur transition-colors hover:border-echo-border/80"
    >
      <Globe className="h-4 w-4 text-muted-foreground" />
      <span className="font-chakra text-xs font-semibold uppercase tracking-wider text-foreground">Reset</span>
    </button>
  );
}
